import { IonButton, IonButtons, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonInput, IonLabel, IonLoading, IonRow, IonTitle, IonToast, IonToolbar } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import "./TaxaServico.css";


type Props = {
  projetoid: string;
  closeAction: Function;
  closeActionSimple: Function;
};

const TaxaServico: React.FC<Props> = (props: Props) => {

  const [showLoading, setShowLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");
  const [taxaServico, setTaxaServico] = useState('');


  const opcoesTaxaServico = [
    { label: '0%', value: '0' },
    { label: '10%', value: '10' },
    { label: '12%', value: '12' },
    { label: '15%', value: '15' }
  ];

  useEffect(() => {
    if (props.projetoid != "") {
      console.log("entrou no useEffect");
    }
  }, []);


  function onChangeValor(e: any) {

    e.persist();
    e.preventDefault();

    let v = e.target.value;

    v = v.replace(/\D/g, '');

    setTaxaServico(v);
  }

  return (

    <>
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">

          <IonButtons slot="start">
            <IonIcon slot="icon-only" icon={arrowBack} onClick={() => {
              props.closeActionSimple();
            }} />
          </IonButtons>
          <IonTitle>Taxa de Serviço</IonTitle>

        </IonToolbar>

      </IonHeader>

      <IonContent fullscreen={false}>

        <IonGrid >
          <IonRow className="ion-justify-content-center" style={{ paddingTop: "20px", textAlign: "center", fontSize: "20px" }}>
            <IonLabel>Selecione uma taxa de serviço ou insira manualmente</IonLabel>
          </IonRow>

          <IonRow className="ion-justify-content-center" style={{ paddingTop: "20px" }}>
            <IonButton
              color={taxaServico === "0" ? "primary" : "light"}
              onClick={() => setTaxaServico("0")}
            >
              0%
            </IonButton>
            <IonButton
              color={taxaServico === "10" ? "primary" : "light"}
              onClick={() => setTaxaServico("10")}
            >
              10%
            </IonButton>
            <IonButton
              color={taxaServico === "12" ? "primary" : "light"}
              onClick={() => setTaxaServico("12")}
            >
              12%
            </IonButton>
            <IonButton
              color={taxaServico === "15" ? "primary" : "light"}
              onClick={() => setTaxaServico("15")}
            >
              15%
            </IonButton>
          </IonRow>

          <IonRow className="ion-justify-content-center" style={{ paddingTop: "20px", textAlign: "center", fontSize: "26px" }}>
            <IonCol size="6">

              <IonInput style={{
                "--background": "#eeeeee",
                borderRadius: "20px",      // Arredonda as bordas
                boxSizing: "border-box"
              }} type="tel" maxlength={14} placeholder="0%" value={taxaServico} onKeyUp={onChangeValor} />

            </IonCol>
          </IonRow>
        </IonGrid>

        <IonToast
          isOpen={showToast}
          position="middle"
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />
      </IonContent>

      <IonFooter>

        <IonToolbar>
          <IonGrid>

            <IonRow>
              <IonCol size="12">
                <IonButton style={{ height: "46px", fontSize: "18px" }} expand="block"
                  type="submit"
                  onClick={async () => {
                    props.closeAction(taxaServico);
                  }}
                >
                  Salvar
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>

        </IonToolbar>
      </IonFooter>
    </>

  );
};

export default ({ projetoid, closeAction, closeActionSimple }: { projetoid: any, closeAction: Function, closeActionSimple: Function }) => (
  <TaxaServico projetoid={projetoid} closeAction={closeAction} closeActionSimple={closeActionSimple}>
  </TaxaServico>
);
